import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Card from '@material-ui/core/Card';
import { Box } from '@material-ui/core';
import { useMutation } from '../../../../../graphql/hooks';
import { CREATE_DISCOUNT, GET_DISCOUNTS } from '../../../graphql';
import { routePaths } from '../../../../../routePaths';
import { OnSubmit } from '../types';
import DiscountForm from '../DiscountForm';
import { Typography } from '../../../../../ui-kit';

const CreateDiscountForm = () => {
    const [createDiscount] = useMutation(CREATE_DISCOUNT, { refetchQueries: [{ query: GET_DISCOUNTS }] });
    const history = useHistory();
    const { t } = useTranslation();

    const onSubmit: OnSubmit = async values => {
        try {
            await createDiscount({ variables: values });
            history.push(routePaths.discounts);
        } catch (error) {
            // nothing we can do
        }
    };

    return (
        <Card>
            <Box px={3} py={5}>
                <Typography variant='h6' component='h1'>{t('Create Discount')}</Typography>
                <DiscountForm
                    submitText={t('Create')}
                    onSubmit={onSubmit}
                />
            </Box>
        </Card>
    );
};

export default CreateDiscountForm;
